import {
  FilterType,
  buildExpensableGroupsDataTableFilter,
} from 'generated/resources/datatable.graphql'
import { ExpensePageFinanceCustomCategoryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'

type Props = BaseFilterProps & {
  subcategories: ExpensePageFinanceCustomCategoryFragment[]
}

const subcategoryFilter = ({ source, subcategories }: Props) => {
  const options = subcategories.map((subcategory) => ({
    label: subcategory.label,
    value: subcategory.identifier,
  }))

  return buildExpensableGroupsDataTableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'expensesList.subcategoryFilter',
    path: 'subcategory',
    title: i18n.t('expenses_v2.forms.fields.subcategory.label'),
  })
}

export default subcategoryFilter
